var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreePoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.26528e-07 7.99943C-8.74811e-07 9.10394 0.89543 9.99933 2 9.99933C3.10457 9.99933 4 9.10394 4 7.99943C4 6.89491 3.10457 5.99953 2 5.99952C0.89543 5.99952 -7.78246e-07 6.89491 -8.26528e-07 7.99943Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.6426e-07 1.99972C-6.12542e-07 3.10424 0.89543 3.99962 2 3.99962C3.10457 3.99962 4 3.10424 4 1.99972C4 0.895204 3.10457 -0.000183145 2 -0.000183193C0.89543 -0.000183241 -5.15978e-07 0.895204 -5.6426e-07 1.99972Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.0888e-06 13.9991C-1.13708e-06 15.1037 0.895429 15.999 2 15.999C3.10457 15.999 4 15.1037 4 13.9991C4 12.8946 3.10457 11.9992 2 11.9992C0.89543 11.9992 -1.04051e-06 12.8946 -1.0888e-06 13.9991Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePoints);
export default __webpack_public_path__ + "static/media/threePoints.dcff07c81b92ecc9351594807c727268.svg";
export { ForwardRef as ReactComponent };